


import React from 'react'

import HotelPinewood from "../images/hotelpinewood.jpg";
import HotelPinewoodroom from "../images/hotelpinewoodrooms.jpg";
import Hotel from "../images/hotels.jpg";
import Header from "../inc/Header";
import { Link } from "react-router-dom";


import Roomimg from "../pages/Roomimg";
import HotelpinewoodroomBooking from './HotelpinewoodroomBooking';

function Hotelpinewood() {
  return (
    <div>
      <Header />
      <br />
      <br />
      <br />
      <br />
      <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-indicators">
          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>

        </div>

        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src={Hotel} className="d-block w-100" alt="hotelpinewood" />
          </div>

          <div className="carousel-item">
            <a href="tel: 9434059296">
              <img src={HotelPinewood} className="d-block w-100" alt="HotelPinewood" /></a>
          </div>
          <div className="carousel-item">
            <a href="tel: 9434059296">
              <img src={HotelPinewoodroom} className="d-block w-100" alt="HotelPinewood" />
            </a>
          </div>
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
      <br />
      <div className="album py-1">
        <div className="container">
          <div className="row">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                <li className="breadcrumb-item"><Link to="/contact" >Contact</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Hotel pinewood</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <HotelpinewoodroomBooking />
      <hr />
      <Roomimg />
    </div>
  )
}

export default Hotelpinewood
